'use strict';
angular.module('schoolLinqApp').factory('unitService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/unit';

		function getUnit() {
			return $http.get(endpoint);
		}

		function getValue(key) {
			return $http.get(endpoint + '/getValue', { params: { key: key } });
		}

		function saveUnit(unit) {
			return $http.post(endpoint, unit);
		}

		function saveValue(key, value) {
			return $http.post(endpoint + '/postValue', { Key: key, Value: value });
		}

		function postFiscalYears(fiscalYears) {
			return $http.post(endpoint + '/fiscalYears', fiscalYears);
		}

		function checkIfMonthsAreClosed(closedMonthJson) {
			return $http.get(endpoint + '/closedMonths', {
				params: { closedMonthJson: closedMonthJson },
			});
		}

		function getFiscalMonths() {
			return $http.get(endpoint + '/getFiscalMonths');
		}

		function getCurrentFiscalYear() {
			return $http.get(endpoint + '/getCurrentFiscalYear');
		}

		function getCurrentFiscalYearStartAndEndDates() {
			return $http.get(endpoint + '/getCurrentFiscalYearStartAndEndDates');
		}

		function getFiscalYearFromDate(value) {
			return $http.get(endpoint + '/getFiscalYearFromDate', {
				params: { value: value },
			});
		}

		function getFiscalYears() {
			return $http.get(endpoint + '/getFiscalYears');
		}

		function getFiscalYearsWithDates() {
			return $http.get(endpoint + '/getFiscalYearsWithDates');
		}

		function getFiscalMonthYearFromCalendarMonthYear(calendarMonth, calendarYear) {
			return $http.get(endpoint + '/getFiscalMonthYearFromCalendarMonthYear', {
				params: { calendarMonth: calendarMonth, calendarYear: calendarYear },
			});
		}

		function getStateInfo() {
			return $http.get(endpoint + '/getStateInfo');
		}

		function getNextVendorCode() {
			return $http.get(endpoint + '/get-next-vendor-code');
		}

		return {
			getUnit: getUnit,
			getValue: getValue,
			saveUnit: saveUnit,
			saveValue: saveValue,
			postFiscalYears: postFiscalYears,
			checkIfMonthsAreClosed: checkIfMonthsAreClosed,
			getFiscalMonths: getFiscalMonths,
			getCurrentFiscalYear: getCurrentFiscalYear,
			getCurrentFiscalYearStartAndEndDates: getCurrentFiscalYearStartAndEndDates,
			getFiscalYearFromDate: getFiscalYearFromDate,
			getFiscalYears: getFiscalYears,
			getFiscalYearsWithDates: getFiscalYearsWithDates,
			getFiscalMonthYearFromCalendarMonthYear: getFiscalMonthYearFromCalendarMonthYear,
			getStateInfo: getStateInfo,
			getNextVendorCode: getNextVendorCode,
		};
	},
]);
